import React, { useState } from 'react'
import { Popover, PopoverContent, PopoverTrigger } from '@shopflo/ui'
import ReportCategories from './ReportCategories'
import { CaretDown , MagnifyingGlass } from '@phosphor-icons/react'
import { Icon, Input, Button } from '@shopflo/ui'
import { useLocale } from 'src/lib/hooks/useLocal'

interface GenerateReportsButtonProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  onReportSelect: (reportId: string) => void
}

const GenerateReportsButton: React.FC<GenerateReportsButtonProps> = ({
  searchQuery,
  onSearchChange,
  onReportSelect
}) => {
  const { t } = useLocale()
  const [open, setOpen] = useState(false)

  const handleOpenChange = (open: boolean) => {
    setOpen(open)
  }

  return (
    <Popover open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <Button variant="primary" size="sm" rightIcon={CaretDown}>
          {t('generate_reports')}
        </Button>
      </PopoverTrigger>

      <PopoverContent sideOffset={4} align='end' className='w-80 border-none p-0 rounded-xl' asChild>
        <div>
          <div className='mx-1.5 pt-1.5 pb-1.5'>
            <div className='relative'>
              <Input
                type='text'
                placeholder='Search reports...'
                value={searchQuery}
                variant="outline"
                onChange={(e) => onSearchChange(e.target.value)}
                dimension="md"
                startAdornment={<Icon IconComponent={MagnifyingGlass} size='sm' className='text-zinc-400' />}
              />
            </div>
          </div>

          <ReportCategories
            searchQuery={searchQuery}
            onReportSelect={reportId => {
              onReportSelect(reportId)
              setOpen(false)
            }}
          />
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default GenerateReportsButton
